import { Article } from "../../services/article";

/** 评价基地一级分类 */
export const EVAL_BASE_PARENT_ID = 189;

/** 评价基地二级分类 ID */
export const CATEGORY_ID_MAP = {
  基地资质: 190,
  评价标准: 191,
  评价制度: 192,
  培训资源: 193,
  证书介绍及报考: 194,
};

/**
 * 规范化富文本中的图片，去掉固定宽高，保证在内容区自适应全宽显示
 */
export function normalizeArticleHtml(html) {
  if (!html) return "";
  return String(html).replace(/<img\b([^>]*)>/gi, (match, attrs) => {
    let cleaned = attrs
      .replace(/\s*width\s*=\s*(["']).*?\1/gi, "")
      .replace(/\s*height\s*=\s*(["']).*?\1/gi, "")
      .replace(/\s*style\s*=\s*(["'])(.*?)\1/gi, (m, quote, style) => {
        const next = style
          .replace(/width\s*:[^;]+;?/gi, "")
          .replace(/height\s*:[^;]+;?/gi, "")
          .trim();
        return next ? ` style=${quote}${next}${quote}` : "";
      });
    return `<img${cleaned} style="max-width:100%;width:100%;height:auto;display:block;margin:0 auto;">`;
  });
}

/**
 * 按分类名称拉取最新一篇文章（单篇展示页）
 */
export function loadCategoryArticle(categoryName) {
  const categoryId = CATEGORY_ID_MAP[categoryName];
  if (!categoryId) return Promise.resolve(null);

  return Article({
    category_id: categoryId,
    page_size: 1,
    page: 1,
  }).then((res) => {
    if (!res || !res.items || !res.items.length) return null;
    const article = { ...res.items[0] };
    if (article.release_time) {
      article.release_time = String(article.release_time).substring(0, 10);
    }
    if (article.content) {
      article.content = normalizeArticleHtml(article.content);
    } else if (article.image) {
      article.content = normalizeArticleHtml(
        `<p style="text-align:center;"><img src="${article.image}"/></p>`
      );
    } else {
      article.content = "";
    }
    return article;
  });
}
